import React from 'react';
import PropTypes from 'prop-types';

const Note = ({note}) => (
  <p
    className="pa3 pa4-ns gray f5"
    dangerouslySetInnerHTML={{
      __html: note,
    }}
  />
);

Note.propTypes = {
  note: PropTypes.string,
};

export default Note;
